import {html, LitElement} from 'lit';
import '@material/mwc-icon-button/mwc-icon-button.js';
import '@material/mwc-icon/mwc-icon.js';
import '@material/mwc-textfield/mwc-textfield.js';
import '@material/mwc-textarea/mwc-textarea.js';
import '@material/mwc-button/mwc-button.js';
import '@material/mwc-checkbox/mwc-checkbox.js';
import '@material/web/dialog/dialog.js';
import '@material/mwc-formfield/mwc-formfield.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';
import '@cbar/cbar-entity-summary/cbar-entity-summary.js';
import '@cbar/cbar-icons/social-icons.js';
import '@cbar/cbar-places-list/cbar-places-list.js';
import '@cbar/cbar-places-list/cbar-places-item.js';
import '@cbar/cbar-chat-client/cbar-chat-client.js';
import '@cbar/cbar-textfield';
import '@cbar/cbar-dropdown';
import '@cbar/cbar-photo-preview/cbar-photo-preview.js';
import '@cbar/cbar-photo-uploader/cbar-photo-uploader.js';
import '@cbar/cbar-location-modal/cbar-location-modal.js';
import {LitLocalize} from '@cbar/lit-localize';
import {DomModule} from '@polymer/polymer/lib/elements/dom-module.js';
import '@polymer/iron-image/iron-image.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/image-icons.js';
import '@cbar/cbar-map';
import '@cbar/cbar-shared-styles';

const themeTemplate = DomModule.import('cbar-shared-styles', 'template');
const sharedThemeElement = themeTemplate?.content?.firstElementChild;

if (!sharedThemeElement) {
  console.warn('The theme template or its first element child is missing.');
}

const sharedTheme = sharedThemeElement?.textContent ?? '';

export class CbarProjectsPage extends LitLocalize(LitElement) {
  static get properties() {
    return {
      title: String,
      description: String,
      url: String,
      phoneNumber: String,
      profileImage: String,
      bannerImage: String,
      selectedTab: String,
      loggedIn: Boolean,
      // Array of Objects containing "type" and "url"
      socials: Array,
      // Array of contacts containing "title" and "description"
      contacts: Array,
      youtubeUrl: String,
      // Array of Strings
      images: Array,
      entityMemberCount: Number,
      language: String,
      // matrix chat user ID
      chatId: String,
      // matrix chat room ID
      chatRoomId: String,
      // matrix chat Access Token
      chatAccessToken: String,
      chatWording: String,
      chatUrl: String,
      displayMailTo: Boolean,
      hideEntityCountDisplay: Boolean,
      contactEmails: Array,
      hideChat: Boolean,
      chatLoading: Boolean,
      hideFollow: Boolean,
      followText: String,
      followingText: String,
      existingClient: Object,
      editing: Boolean,
      editable: Boolean,
      noContacts: Boolean,
      hideBanner: Boolean,
      hideImages: Boolean,
      stickyOffset: Number,
      __uploadedImages: Array,
      maxCropperWidth: Number,
      maxCropperHeight: Number,
      downloadUrl: String,
      address: Object,
      hideAddress: Boolean,
      mapLocation: Object,
      googleApiKey: String,
      memberCountWording: String,
      disableProfileEdit: Boolean,
      withToast: Boolean
    };
  }

  get title() {
    return this._title;
  }

  get contacts() {
    return this._contacts;
  }

  get selectedTab() {
    return this._selectedTab;
  }

  get hideChat() {
    return this._hideChat;
  }

  get existingClient() {
    return this._existingClient;
  }

  get description() {
    return this._description;
  }

  get profileImage() {
    return this._profileImage;
  }

  get bannerImage() {
    return this._bannerImage;
  }

  get hideEntityCountDisplay() {
    return this._hideEntityCountDisplay;
  }

  get socials() {
    return this._socials;
  }

  get youtubeUrl() {
    return this._youtubeUrl;
  }

  get displayMailTo() {
    return this._displayMailTo;
  }

  get images() {
    return this._images;
  }

  get url() {
    return this._url;
  }

  get phoneNumber() {
    return this._phoneNumber;
  }

  get loggedIn() {
    return this._loggedIn;
  }

  get contactEmails() {
    return this._contactEmails;
  }

  get entityMemberCount() {
    return this._entityMemberCount;
  }

  get hideFollow() {
    return this._hideFollow;
  }

  get chatId() {
    return this._chatId;
  }

  get chatRoomId() {
    return this._chatRoomId;
  }

  get chatAccessToken() {
    return this._chatAccessToken;
  }

  get followText() {
    return this._followText;
  }

  get followingText() {
    return this._followingText;
  }

  get editing() {
    return this._editing;
  }

  get editable() {
    return this._editable;
  }

  get noContacts() {
    return this._noContacts;
  }

  get hideBanner() {
    return this._hideBanner;
  }

  get hideImages() {
    return this._hideImages;
  }

  get stickyOffset() {
    return this._stickyOffset;
  }

  get __uploadedImages() {
    return this._uploadedImages;
  }

  get maxCropperHeight() {
    return this._maxCropperHeight;
  }

  get maxCropperWidth() {
    return this._maxCropperWidth;
  }

  get downloadUrl() {
    return this._downloadUrl;
  }

  get address() {
    return this._address;
  }

  get hideAddress() {
    return this._hideAddress;
  }

  get mapLocation() {
    return this._mapLocation;
  }

  get googleApiKey() {
    return this._googleApiKey;
  }

  get memberCountWording() {
    return this._memberCountWording;
  }

  get disableProfileEdit() {
    return this._disableProfileEdit;
  }

  get withToast() {
    return this._withToast;
  }

  get imagePreview() {
    if (!this._imagePreview) {
      this._imagePreview = this.shadowRoot.querySelector('cbar-photo-preview');
    }
    return this._imagePreview;
  }

  get imageNav() {
    if (!this._imageNav) {
      this._imageNav = this.shadowRoot.querySelector('.album');
    }
    return this._imageNav;
  }

  get contactDialog() {
    if (!this._contactDialog) {
      this._contactDialog = this.shadowRoot.querySelector('.contact-dialog');
    }
    return this._contactDialog;
  }

  get editEmailsDialog() {
    if (!this._editEmails) {
      this._editEmails = this.shadowRoot.querySelector('.emails-dialog');
    }
    return this._editEmails;
  }

  get editContactsDialog() {
    if (!this._contactsDialog) {
      this._contactsDialog = this.shadowRoot.querySelector('.contacts-dialog');
    }
    return this._contactsDialog;
  }

  get phoneDialog() {
    if (!this._phoneDialog) {
      this._phoneDialog = this.shadowRoot.querySelector('.phone-dialog');
    }
    return this._phoneDialog;
  }

  get youtubeDialog() {
    if (!this._youtubeDialog) {
      this._youtubeDialog = this.shadowRoot.querySelector('.youtube-dialog');
    }
    return this._youtubeDialog;
  }

  get socialDialog() {
    if (!this._socialDialog) {
      this._socialDialog = this.shadowRoot.querySelector('.social-dialog');
    }
    return this._socialDialog;
  }

  get addImageDialog() {
    if (!this._addImageDialog) {
      this._addImageDialog = this.shadowRoot.querySelector('.images-dialog');
    }
    return this._addImageDialog;
  }

  get chatClientDiv() {
    if (!this._chatClient) {
      this._chatClient = this.shadowRoot.querySelector('.chat-client');
    }
    return this._chatClient;
  }

  get confirmDialog() {
    if (!this._confirmDialog) {
      this._confirmDialog = this.shadowRoot.querySelector(
        '.confirmation-dialog'
      );
    }
    return this._confirmDialog;
  }

  get horizontalDiv() {
    if (!this.__horizontalDiv) {
      this.__horizontalDiv =
        this.shadowRoot.querySelector('.horizontal-scroll');
    }
    return this.__horizontalDiv;
  }

  get photoUploader() {
    if (!this._photoUploader) {
      this._photoUploader = this.shadowRoot.querySelector(
        'cbar-photo-uploader'
      );
    }
    return this._photoUploader;
  }

  // generates an appropriate button with naming and actions depending on whether the element is logged in or not
  get contactFormSubmitButton() {
    return this.loggedIn
      ? html`
        ${!this.displayMailTo
          ? html`
            <mwc-button
              @tap="${e => {
                this.submitContactForm(e);
              }}"
              slot="primaryAction"
            >${this.localize('Submit')}
            </mwc-button>
          `
          : html``}
      `
      : html`
        <mwc-button
          @tap="${e => {
            this.fireLogIn(e);
          }}"
          slot="primaryAction"
        >${this.localize('Log In')}
        </mwc-button>`;
  }

  get addressSection() {
    return this.displayAddress
      ? html`
        ${this.editing
          ? html`
            <h5 style="margin-top:6px">${this.localize('Address')}</h5>
            <cbar-location-modal
              ?hideDelete="${!this.editing}"
              title="${this.address.title}"
              locationType="${this.address.type}"
              customLocationType="${this.address.customType}"
              state="${this.address.state}"
              suburb="${this.address.suburb}"
              streetAddress1="${this.address.streetAddress1}"
              streetAddress2="${this.address.streetAddress2}"
              streetAddress3="${this.address.streetAddress3}"
              postcode="${this.address.postcode}"
              country="${this.address.country}"
              apiKey="${this.googleApiKey}"
              @entry-deleted="${e => {
                this.deleteAddress(e);
              }}"
            ></cbar-location-modal>
          `
          : html`
            <cbar-map style="height: 200px; z-index: 0;position: relative;"></cbar-map> `}
      `
      : html``;
  }

  // if we dont have a video link for youtube to display, the iframe can display quite ugly, so we dont display the iframe
  get youtubeSection() {
    return this.youtubeUrl ? html`
      <div class="card iframe-container">
        <iframe
          src="${this.youtubeUrl}"
          frameborder="0"
          height="200"
        ></iframe>

        ${this.editing ? html`
          <div class="editing-iframe background-color-animation"
            @tap="${() => {this.toggleDialog(this.youtubeDialog);}}"
          >
            <iron-icon icon="image:edit"></iron-icon>
          </div>
        ` : html``}
      </div>
      </div>
    ` : html`
      ${this.editing ? html`
          <div class="card iframe-container" style="opacity: 1;">
            <div class="editing-iframe background-color-animation"
              @tap="${() => {this.toggleDialog(this.youtubeDialog);}}"
            >
              <iron-icon icon="image:edit"></iron-icon>
            </div>
          </div>
        `
        : html``}
    `;
  }

  get editingSection() {
    return this.editing ? html`
      <mwc-button @tap="${() => {this.cancelEdit();}}">${this.localize('Cancel')}</mwc-button>
      <mwc-button raised @tap="${() => {this.confirmEdit();}}">${this.localize('Confirm')}</mwc-button>
    ` : html`
      <mwc-button raised @tap="${() => {this.editing = true;}}">${this.localize('Edit')}</mwc-button>
    `;
  }

  get chatButton() {
    return this.loggedIn
      ? html``
      : html`
        <mwc-button
          @tap="${e => {
            this.fireLogIn(e);
          }}"
          slot="primaryAction"
        >${this.localize('Log In')}
        </mwc-button>`;
  }

  // gets the inputs that rely on a value property inside the contact dialog, we then check the checkbox seperately
  get contactFormInputs() {
    if (!this._contactFormInputs) {
      this._contactFormInputs = this.shadowRoot.querySelectorAll(
        'mwc-textfield.contact-form-input, mwc-textarea.contact-form-input'
      );
    }
    return this._contactFormInputs;
  }

  get contactsList() {
    if (!this._contactsList) {
      this._contactsList = this.shadowRoot?.querySelector('cbar-places-list');
    }
    return this._contactsList;
  }

  get descriptionDiv() {
    if (!this._descriptionDiv) {
      this._descriptionDiv = this.shadowRoot?.querySelector(
        '.thank-you-description'
      );
    }
    return this._descriptionDiv;
  }

  get addressInput() {
    return this.shadowRoot?.querySelector('cbar-location-modal');
  }

  get map() {
    return this.shadowRoot?.querySelector('cbar-map');
  }

  get socialDropdown() {
    if (!this._socialDropdown) {
      this._socialDropdown = this.shadowRoot.querySelector('.social-dropdown');
    }
    return this._socialDropdown;
  }

  get socialTextfield() {
    if (!this._socialTextfield) {
      this._socialTextfield = this.shadowRoot.querySelector('.social-value');
    }
    return this._socialTextfield;
  }

  get imagesTextfield() {
    if (!this._imagesTextfield) {
      this._imagesTextfield = this.shadowRoot.querySelector('.images-input');
    }
    return this._imagesTextfield;
  }

  get emailsDialogElement() {
    return html`
      <md-dialog scrimClickAction="" class="emails-dialog" >
        <h6 slot="headline">${this.localize('Edit Contact Emails')}</h6>
        <div style="display: flex; flex-direction: column" slot="content">
          ${this.contactEmails ? this.contactEmails.map(email => html`
              <div style="display: flex; align-items: center">
                <cbar-textfield
                  required
                  pattern="${this.__emailValidationRegex}"
                  validationMessage="${this.localize(
                    'This Field is Invalid'
                  )}"
                  class="email-input"
                  value="${email}"
                  label="Email"
                ></cbar-textfield>
                <mwc-icon-button
                  icon="delete"
                  @tap="${() => {this.__handleContactEmailRemove(email);}}"
                ></mwc-icon-button>
              </div>
          `) : html``}
          <div style="display: flex;">
            <div style="cursor:pointer"
              @tap="${() => {this.__addNewContactEmail();}}">
              ${this.localize('Add Another')}
            </div>
          </div>
        </div>

        <div slot="actions">
            <mwc-button slot="primaryAction" @tap="${() => {this.__handleContactEmails();}}">${this.localize('Confirm')}</mwc-button>
        </div>
      </md-dialog>`;
  }

  get socialDialogElement() {
    return html`
      <md-dialog class="social-dialog">
        <h6 slot="headline">${this.localize('Edit Social Settings')}</h6>
        <div slot="content">
          <!-- HACK -->
          <div style="position: fixed;z-index: 1;">
            <cbar-dropdown
              required
              error-message="Required"
              @change="${e => {
                this.__checkForExistingSocial(e);
              }}"
              class="social-dropdown"
              style="width: 100%"
              label="${this.localize('Type')}"
              .items="${this.getPossibleSocials()}"
            ></cbar-dropdown>
          </div>
          <cbar-textfield
            required
            validationMessage="${this.localize('This Field is Invalid')}"
            class="social-value"
            style="margin-top: 70px;width: 100%"
            label="${this.localize('Value')}"
          ></cbar-textfield>
        </div>
        <div slot="actions">
          <div slot="secondaryAction">
            <mwc-button class="delete-button" @tap="${() => {this.__handleSocialAction('delete');}}">${this.localize('Delete')}</mwc-button>
            <mwc-button  @tap="${() => {this.__handleSocialAction('cancel');}}">${this.localize('Cancel')}</mwc-button>
          </div>
          <mwc-button
            slot="primaryAction"
            @tap="${() => {requestAnimationFrame(() => {this.__handleSocialAction(this.__newAction);});}}"
          >${this.localize('Confirm')}</mwc-button>
        </div>
      </md-dialog>`;
  }

  get youtubeDialogElement() {
    return html`
      <md-dialog class="youtube-dialog">
        <h6 slot="headline">${this.localize('Update Youtube Url')}</h6>
        <div style="display: flex; flex-direction: column" slot="content">
          <cbar-textfield
            class="youtube-url"
            label="Url"
            value="${this.youtubeUrl}"
            validationMessage="${this.localize('This Field is Invalid')}"
            pattern="${this.__urlValidationRegex}"
            style="width: 100%"
          ></cbar-textfield>
        </div>
        <div slot="actions">
          <div>
            ${this.youtubeUrl ? html`
                <mwc-button class="delete-button" @tap="${() => {this.__handleYoutubeDelete();}}">
                  ${this.localize('Delete')}
                </mwc-button>`
              : html``}
            <mwc-button @tap="${() => {this.cancelYoutubeEdit();}}">${this.localize('Cancel')}</mwc-button>
          </div>
          <mwc-button slot="primaryAction" @tap="${() => {this.__handleNewYoutube();}}">${this.localize('Confirm')}
          </mwc-button>
        </div>
      </md-dialog>
    `;
  }

  get editContactsDialogElement() {
    return html`
      <md-dialog scrimClickAction="" class="contacts-dialog">
        <h6 slot="headline">${this.localize('Confirm Contact Details')}</h6>
        <div style="display:flex;flex-direction: column" slot="content">
          <cbar-textfield
            class="contact-input"
            name="title"
            required
            pattern="${this.__titleValidationRegex}"
            validationMessage="${this.localize('This Field is Invalid')}"
            label="${this.localize('Title')}"
            value="${this.__selectedContact
              ? this.__selectedContact.title
              : null}"
          ></cbar-textfield>
          <cbar-textfield
            class="contact-input"
            name="description"
            required
            pattern="${this.__titleValidationRegex}"
            validationMessage="${this.localize('This Field is Invalid')}"
            label="${this.localize('Description')}"
            value="${this.__selectedContact
              ? this.__selectedContact.description
              : null}"
          ></cbar-textfield>
          <cbar-textfield
            class="contact-input"
            name="image"
            required
            pattern="${this.__urlValidationRegex}"
            validationMessage="${this.localize('This Field is Invalid')}"
            label="${this.localize('Image Url')}"
            value="${this.__selectedContact
              ? this.__selectedContact.image
              : null}"
          ></cbar-textfield>
        </div>

        <div slot="actions">
          <div slot="secondaryAction">
            <mwc-button class="delete-button" @tap="${() => {this.__handleContactDeleted(this.__selectedContact);}}">${this.localize(this.__creatingNewContact ? 'Cancel' : 'Delete')}</mwc-button>
            ${!this.__creatingNewContact
              ? html`
                <mwc-button @tap="${() => {this.editContactsDialog.close()}}">${this.localize('Cancel')}</mwc-button>`
              : html``}
          </div>
          <mwc-button
            slot="primaryAction"
            @tap="${e => {this.__confirmEditContact(e);}}">${this.localize('Confirm')}
          </mwc-button>
        </div>
      </md-dialog>
    `;
  }

  get addImageDialogElement() {
    return html`
      <md-dialog class="images-dialog" heading="${this.localize('Add New Image')}">
        <h6 slot="headline">${this.localize('Add New Image')}</h6>
        <div slot="content">
          <cbar-textfield
            style="width: 100%"
            class="images-input"
            name="url"
            required
            pattern="${this.__urlValidationRegex}"
            validationMessage="${this.localize('This Field is Invalid')}"
            label="${this.localize('Url')}"
          ></cbar-textfield>
        </div>

        <div slot="actions">
          <mwc-button slot="secondaryAction" @tap="${() => {this.addImageDialog.close()}}">${this.localize('Cancel')}</mwc-button>
          <mwc-button slot="primaryAction" @tap="${e => {this.__confirmAddedImage(e);}}">${this.localize('Confirm')}</mwc-button>
        </div>
      </md-dialog>
    `;
  }

  get localesFile() {
    return this._localesFile;
  }

  set profileImage(image) {
    this._profileImage = image;
    this.requestUpdate();
  }

  set hideChat(hide) {
    this._hideChat = hide;
    this.calculateHasSocials();
    this.requestUpdate();
  }

  set contacts(admins) {
    if (typeof admins === "string") {
      // eslint-disable-next-line no-param-reassign
      admins = JSON.parse(admins);
    }

    this._contacts = admins;
    this.requestUpdate();

    if (!this.contactsList) {
      return;
    }

    this.contactsList.items = admins;
  }

  set title(title) {
    this._title = title;
    this.requestUpdate();
  }

  set selectedTab(tab) {
    this._selectedTab = tab;
    this.requestUpdate();
  }

  set bannerImage(image) {
    this._bannerImage = image;
    this.requestUpdate();
  }

  set description(description) {
    this._description = description;

    requestAnimationFrame(() => {
      if (this.descriptionDiv) {
        this.descriptionDiv.hidden = !description && !this.editing;
        this.descriptionDiv.innerHTML = description;
      }
    });

    this.requestUpdate();
  }

  set existingClient(existingClient) {
    this._existingClient = existingClient;
    this.requestUpdate();
  }

  set socials(socials) {
    if (typeof socials === "string") {
      // eslint-disable-next-line no-param-reassign
      socials = JSON.parse(socials);
    }

    this._socials = socials;
    this.calculateHasSocials();
    this.requestUpdate();
  }

  set youtubeUrl(url) {
    this._youtubeUrl = url;
    this.requestUpdate();
  }

  set contactEmails(emails) {
    this._contactEmails = emails;
    this.calculateHasSocials();
    this.requestUpdate();
  }

  set hideFollow(follow) {
    this._hideFollow = follow;
    this.requestUpdate();
  }

  set hideEntityCountDisplay(display) {
    this._hideEntityCountDisplay = display;
    this.requestUpdate();
  }

  set images(images) {
    if (typeof images === "string") {
      // eslint-disable-next-line no-param-reassign
      images = JSON.parse(images);
    }

    this._images = images;
    this.requestUpdate();

    if (images && images.length > 0) {
      requestAnimationFrame(() => {
        this.__calculateHorizontalDisplay();
      });
    }
  }

  set url(url) {
    this._url = url;
    this.calculateHasSocials();
    this.requestUpdate();
  }

  set phoneNumber(number) {
    this._phoneNumber = number;
    this.calculateHasSocials();
    this.requestUpdate();
  }

  set loggedIn(loggedIn) {
    this._loggedIn = loggedIn;
    this.requestUpdate();
  }

  set entityMemberCount(count) {
    this._entityMemberCount = count;
    this.requestUpdate();
  }

  set localesFile(file) {
    this._localesFile = file;
    this.requestUpdate();
  }

  set chatId(id) {
    this._chatId = id;
    this.requestUpdate();
  }

  set chatRoomId(id) {
    this._chatRoomId = id;
    this.requestUpdate();
  }

  set chatAccessToken(token) {
    this._chatAccessToken = token;
    this.requestUpdate();
  }

  set displayMailTo(mailto) {
    this._displayMailTo = mailto;
    this.requestUpdate();
  }

  set followText(followText) {
    this._followText = followText;
    this.requestUpdate();
  }

  set followingText(followingText) {
    this._followingText = followingText;
    this.requestUpdate();
  }

  set memberCountWording(memberCountWording) {
    this._memberCountWording = memberCountWording;
    this.requestUpdate();
  }

  set disableProfileEdit(disableProfileEdit) {
    this._disableProfileEdit = disableProfileEdit;
    this.requestUpdate();
  }

  set editing(editing) {
    this._editing = editing;

    if (this.descriptionDiv) {
      this.descriptionDiv.hidden = !this.description && !editing;
    }

    this.displayAddress = !this.hideAddress && editing;

    if (this.addressInput) {
      this.addressInput.hideDelete = !editing;
    }

    if (editing) {
      this.handleInitialEdit();
    }

    this.requestUpdate();
  }

  set editable(editable) {
    this._editable = editable;
    this.requestUpdate();
  }

  set noContacts(noContacts) {
    this._noContacts = noContacts;
    this.requestUpdate();
  }

  set hideBanner(hideBanner) {
    this._hideBanner = hideBanner;
    this.requestUpdate();
  }

  set hideImages(hideImages) {
    this._hideImages = hideImages;
    this.requestUpdate();
  }

  set stickyOffset(stickyOffset) {
    this._stickyOffset = stickyOffset;
    this.requestUpdate();
  }

  set __uploadedImages(images) {
    this._uploadedImages = images;
    this.requestUpdate();
  }

  set maxCropperWidth(maxCropperWidth) {
    this._maxCropperWidth = maxCropperWidth;
    this.requestUpdate();
  }

  set maxCropperHeight(maxCropperHeight) {
    this._maxCropperHeight = maxCropperHeight;
    this.requestUpdate();
  }

  set downloadUrl(downloadUrl) {
    this._downloadUrl = downloadUrl;
    this.calculateHasSocials();
    this.requestUpdate();
  }

  set address(address) {
    if (typeof address === "string") {
      // eslint-disable-next-line no-param-reassign
      address = JSON.parse(address);
    }

    this._address = address;

    const requiredFields = [
      'streetAddress1',
      'suburb',
      'state',
      'postcode',
      'country',
    ];

    const hasAllKeys = address
      ? requiredFields.every(
        key =>
          Object.prototype.hasOwnProperty.call(address, key) && !!address[key]
      )
      : false;

    this.displayAddress =
      !this.hideAddress && this.googleApiKey && (hasAllKeys || this.editing);

    if (hasAllKeys && !this.hideAddress) {
      if (address.lat && address.lng) {
        requestAnimationFrame(() => {
          this.mapLocation = {
            lat: address.lat,
            lng: address.lng,
            title: address.title ? address.title : this.title,
            description: this.formatAddressForGoogle(),
          };
        });
      } else {
        this.handleGoogleMap();
      }
    }

    this.requestUpdate();
  }

  set hideAddress(hide) {
    this._hideAddress = hide;
    if (hide) {
      this.displayAddress = false;
    }
    this.requestUpdate();
  }

  set mapLocation(mapLocation) {
    this._mapLocation = mapLocation;

    requestAnimationFrame(() => {
      if (this.map) {
        this.map.location = mapLocation;
      }
    });

    this.requestUpdate();
  }

  set googleApiKey(key) {
    this._googleApiKey = key;
    this.hideAddress = !key;
    this.requestUpdate();
  }

  set withToast(withToast) {
    this._withToast = withToast;
    this.requestUpdate();
  }

  // we need to fetch our social icons from the header element of the document
  // this allows for us to use our polymer icon element without needing converstion
  // TODO: update the icons element to be compatable with LIT
  getSocialSvg(type) {
    if (!this._socialIcons) {
      this._socialIcons = {};
    }

    // the first time these are fetched the path html gets removed from the head tag, we save this below
    // when we request this.requestUpdate, instead of fetching from the query, we select from the object
    const iconset = this._socialIcons[type]
      ? this._socialIcons[type]
      : document.querySelector(`iron-iconset-svg[name=cbar] g#${type} path`);

    if (!iconset) {
      return null;
    }

    // setting the object prop here
    this._socialIcons[type] = iconset;

    return iconset;
  }

  // eslint-disable-next-line class-methods-use-this
  getPossibleSocials() {
    return [
      {
        id: 'facebook',
        title: 'Facebook',
      },
      {
        id: 'instagram',
        title: 'Instagram',
      },
      {
        id: 'linkedin',
        title: 'LinkedIn',
      },
      {
        id: 'tiktok',
        title: 'Tiktok',
      },
      {
        id: 'twitter',
        title: 'X',
      },
      {
        id: 'google-plus',
        title: 'Google',
      },
      {
        id: 'youtube',
        title: 'Youtube',
      },
      {
        id: 'fitbit',
        title: 'Fitbit',
      },
      {
        id: 'web',
        title: 'Website',
      },
      {
        id: 'download',
        title: 'Download Url',
      },
      {
        id: 'phone',
        title: 'Phone Number',
      },
    ];
  }

  // when we click on an image we set the image of the preview modal and then open it
  handleImageClicked(image, index) {
    this.imagePreview.image = image;
    requestAnimationFrame(() => {
      this.imagePreview.open = true;
    });

    this.selectedImageIndex = index;
  }

  handleImageNavigate(direction) {
    if (!this.imagePreview) {
      return;
    }

    // we check which direction of the array we have to navigate here
    // math logic example: 1+-1 = 0
    const index = this.selectedImageIndex;
    const math = direction === 'back' ? -1 : 1;

    if (index + math >= this.images.length || index + math < 0) {
      return;
    }

    this.selectedImageIndex = index + math;

    this.imagePreview.image = this.images[index + math];
  }

  // scroll the div sideways by an image with when we click on the nav buttons
  handleImageNav(distance) {
    this.imageNav.scrollLeft += this.imageNav.scrollLeft + distance;
  }

  submitContactForm() {
    const sendCopyCheckbox = this.shadowRoot.querySelector(
      'mwc-checkbox.contact-form-input'
    );

    const eventData = {};
    let isValid = true;

    this.contactFormInputs.forEach(input => {
      // NOTE: reportValidity is the replacement for the polymer 3 validate() function
      if (!!input.reportValidity && !input.reportValidity(input)) {
        isValid = false;
        return;
      }

      eventData[input.name] = input.value;
    });

    // we need to check the checkbox seperately here, due to the nature of its "selection" property
    // it will act differently to those who rely on "value"
    if (sendCopyCheckbox.checked) {
      eventData.sendCopy = true;
    }

    if (!isValid) {
      return;
    }

    this.dispatchEvent(
      new CustomEvent('contact-submitted', {
        bubbles: true,
        composed: true,
        detail: {value: eventData},
      })
    );

    this.contactDialog.close();
  }

  handleContactDialogClose() {
    let confirming = false;
    this.contactFormInputs.forEach(input => {
      if (input.value) {
        confirming = true;
        this.confirmDialog.show();
      }
    });

    if (confirming === false) {
      this.contactDialog.close();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  toggleDialog(dialog) {
    // eslint-disable-next-line no-param-reassign
    dialog.open ? dialog.close() : dialog.show();
  }

  // function that allows for our analytics ngn to listen to links that are clicked inside this element
  // we then pass a url and a callback function to perform any possible actions that the button may need to carry
  // out, an example of this would be opening a new page to a url, or opening a dialog via the callback function
  handleSocialClicked(type, url, callback) {
    this.dispatchEvent(
      new CustomEvent('social-clicked', {
        bubbles: true,
        composed: true,
        detail: {value: type},
      })
    );

    // if we are editing and have a url for the social link, we need to open the editing dialog here
    if (this.editing && url) {
      this.__handleSocialEditing(type);
      return;
    }

    // if theres no custom callback for the button, we simply open the url
    if (url && !callback && type !== 'phone') {

      if (!url.match(/^https?:\/\//i)) {
        url = 'http://' + url;
      }

      window.open(url);
    }

    // call any custom fallback here
    if (callback) {
      callback();
    }
  }

  calculateHasSocials() {
    const arrayOfReliantProps = [
      this.contactEmails,
      this.socials,
      this.url,
      this.downloadUrl,
      this.phoneNumber,
      !this.hideChat,
    ];

    let hasConnect = false;
    /* eslint-disable no-param-reassign */
    arrayOfReliantProps.forEach(prop => {
      if (!prop) {
        return;
      }

      let propertyToCheck = prop.valueOf();

      if (Array.isArray(propertyToCheck)) {
        propertyToCheck = propertyToCheck.length > 0;
      }

      if (!hasConnect && !!propertyToCheck) {
        hasConnect = true;
      }
    });

    this.__hasConnect = hasConnect;
    return this.__hasConnect;
  }

  confirmContactCancel() {
    /* eslint-disable no-param-reassign */
    this.contactFormInputs.forEach(input => {
      input.value = '';
    });

    this.confirmDialog.close();
    this.contactDialog.close();
  }

  // fires a login event here, this would, in passport get us to handle the login process, and then set the prop 'loggedIn to true'
  fireLogIn() {
    this.dispatchEvent(
      new CustomEvent('login-clicked', {
        bubbles: true,
        composed: true,
      })
    );
  }

  __handleChatTapped() {
    this.chatClientDiv.scrollIntoView();
    // use for analytics, we can also pass in the chat props on this event to lazy load the API
    this.dispatchEvent(
      new CustomEvent('chat-clicked', {
        bubbles: true,
        composed: true,
      })
    );
  }

  __calculateHorizontalDisplay() {
    const divsToResize = this.shadowRoot.querySelectorAll('.nav-section');

    divsToResize.forEach(div => {
      this.horizontalDiv.addEventListener('scroll', () => {
        this.__calculateHorizontalDivDisplay(div);
      });
    });

    if (this.horizontalDiv) {
      this.horizontalDiv.dispatchEvent(new Event('scroll'));
    }
  }

  __calculateHorizontalDivDisplay(div) {
    div.hidden =
      div.dataset.direction === 'Left'
        ? this.horizontalDiv.scrollLeft === 0
        : this.horizontalDiv.scrollLeft + this.horizontalDiv.offsetWidth ===
        this.horizontalDiv.scrollWidth;
  }

  // when we confirm the edit we dont reset to the history value
  // we send an event out that can be listened on it order to send to REST API's for example
  confirmEdit() {
    this.editing = false;

    this.address = this.getAddressFromElement();

    const details = {
      title: this.title,
      description: this.descriptionDiv.innerHTML,
      youtubeUrl: this.youtubeUrl,
      socials: this.socials,
      phoneNumber: this.phoneNumber,
      url: this.url,
      downloadUrl: this.downloadUrl,
      chatRoomId: this.chatRoomId,
      contactEmails: this.contactEmails,
      images: this.images,
      contacts: this.contacts,
      uploadedImages: this.__uploadedImages,
      address: this.address,
    };

    this.__handleScroll();

    this.dispatchEvent(
      new CustomEvent('edit-confirmed', {
        bubbles: true,
        composed: true,
        detail: details,
      })
    );

    // ensure our description gets restamped
    this.description = this.descriptionDiv.innerHTML;
  }

  // reverts to last history save
  cancelEdit() {
    this.editing = false;

    this.__handleScroll();

    this.descriptionDiv.innerHTML = this.__initialDescription;
    this.youtubeUrl = this.__initialYoutubeUrl;
    this.socials = this.__initialSocials;
    this.url = this.__initialWeb;
    this.downloadUrl = this.__initialDownloadUrl;
    this.phoneNumber = this.__initialPhone;
    this.contactEmails = this.__initialEmails;
    this.contacts = this.__initialContacts;
    this.images = this.__initialImages;

    this.bannerImage = this.__initialBannerImage;
    this.profileImage = this.__initialProfileImage;

    this.address = this.__initialAddress;

    this.__uploadedImages = [];

    const youtubeInput = this.shadowRoot.querySelector(
      'cbar-textfield.youtube-url'
    );
    if (youtubeInput) {
      youtubeInput.value = this.__initialYoutubeUrl;
    }

    [this.socialTextfield, this.imagesTextfield].forEach(input => {
      input.value = '';
      input.required = false;
      requestAnimationFrame(() => {
        input.required = true;
      });
    });

    requestAnimationFrame(() => {
      this.__restampContacts();
    });
  }

  // history control
  handleInitialEdit() {
    this.__initialProfileImage = this.profileImage;
    this.__initialBannerImage = this.bannerImage;

    this.__initialDescription = this.description;
    this.__initialYoutubeUrl = this.youtubeUrl;
    this.__initialSocials = JSON.parse(JSON.stringify(this.socials));
    this.__initialContacts = JSON.parse(JSON.stringify(this.contacts));
    this.__initialWeb = this.url;
    this.__initialDownloadUrl = this.downloadUrl;
    this.__initialPhone = this.phoneNumber;
    this.__initialEmails = this.contactEmails ? [...this.contactEmails] : [];
    this.__initialImages = this.images ? [...this.images] : [];
    this.__initialAddress = this.address;
  }

  // allows us to set the youtube embeds url
  __handleNewYoutube() {
    const newInput = this.shadowRoot.querySelector(
      'cbar-textfield.youtube-url'
    );

    newInput.setCustomValidity('');

    if (!newInput.reportValidity()) {
      newInput.setCustomValidity(this.localize('This Field is Invalid'));
      return;
    }

    if (!newInput.value) {
      newInput.setCustomValidity(this.localize('This Field is Invalid'));
      newInput.reportValidity();
      return;
    }

    const youtubeId = this.getYoutubeIdFromUrl(newInput.value);

    if (!youtubeId) {
      newInput.setCustomValidity(this.localize('This Field is Invalid'));
      newInput.reportValidity();
      return;
    }

    const formattedYoutubeUrl = `https://www.youtube.com/embed/${youtubeId}`;

    if (newInput) {
      // we need the youtube url to be removed if the value is cleared
      this.youtubeUrl = formattedYoutubeUrl || '';
    }

    this.toggleDialog(this.youtubeDialog);
  }

  __handleYoutubeDelete() {
    this.youtubeUrl = '';
    this.toggleDialog(this.youtubeDialog);
  }

  // function that handles all of the social editing dialog options
  __handleSocialAction(action) {
    if(action === "cancel"){
      this.socialDialog.close();
      return
    }

    // check whether we have an existing social option here
    const socialValue = this.socials.find(
      social => social.type === this.socialDropdown.value
    );
    // binding for map functions
    const element = this;

    if (action !== 'delete') {
      // validate both of the inputs inside the dialog
      const dropDownValid = this.socialDropdown.validate();
      const textFieldValid = this.socialTextfield.reportValidity();

      const isValid = dropDownValid && textFieldValid;

      if (!isValid) {
        return;
      }
    }

    // map our actions to functions
    const validActions = {
      edit: this.__handleEditSocial.bind(element),
      new: this.__handleNewSocial.bind(element),
      delete: this.__deleteSocial.bind(element),
    };

    // some of our types need custom props to be set differently to our social object
    // identify the mapping from the option to the prop it controls here
    const extraValueChecks = {
      web: 'url',
      phone: 'phoneNumber',
      chat: 'chatRoomId',
      download: "downloadUrl"
    };

    console.log(this.socialDropdown.value);

    let customValueChecked = false;
    // we check our custom values here first in order to ensure they get set correctly
    if (Object.keys(extraValueChecks).includes(this.socialDropdown.value)) {
      if (action === 'delete') {
        this.socialTextfield.value = '';
      }

      this[extraValueChecks[this.socialDropdown.value]] = this.socialTextfield
        .value
        ? this.socialTextfield.value
        : null;
      customValueChecked = true;
    }

    // either were editing or deleting an existing option, or adding a new one
    if ((socialValue || action === 'new') && !customValueChecked) {
      // eslint-disable-next-line babel/no-unused-expressions
      validActions[action](socialValue);
    }

    this.toggleDialog(this.socialDialog);

    this.socialDropdown.value = '';
    this.socialTextfield.value = '';

    this.socialDropdown.required = false;
    requestAnimationFrame(() => {
      this.socialDropdown.required = true;
    });
  }

  __handleEditSocial(socialValue) {
    // we set the url here for existing socal types in our object, we never change the type
    this.socials[this.socials.indexOf(socialValue)].url =
      this.socialTextfield.value;
  }

  // eslint-disable-next-line no-unused-vars
  __handleNewSocial(socialValue) {
    // setting it this way allows the restamp to occur without requesting an update
    this.socials = [
      ...this.socials,
      {
        type: this.socialDropdown.value,
        url: this.socialTextfield.value,
      },
    ];
  }

  __deleteSocial(socialValue) {
    // splice sets the original array to the result of removing, returns the removed value
    this.socials.splice(this.socials.indexOf(socialValue), 1);
    // we need the splice to restamp the array, so we request this here
    this.requestUpdate();
    this.socialTextfield.value = '';

    this.socialTextfield.required = false;
    requestAnimationFrame(() => {
      this.socialTextfield.required = true;
    });
  }

  __handleSocialEditing(type) {
    this.toggleDialog(this.socialDialog);
    this.socialDropdown.value = type;
    // we fire the event we listen on here manually in order for the listener to pick up whenever we open the dialog
    this.socialDropdown.dispatchEvent(new CustomEvent('change'));

    requestAnimationFrame(() => {
      this.socialTextfield.reportValidity();
    });
  }

  __checkForExistingSocial(e) {
    const {value} = e.target;

    // custom map here for some extra values we can use the basic social dialog for
    const customMap = {
      web: {
        validation: this.__urlValidationRegex,
        value: 'url',
      },
      phone: {
        validation: '',
        value: 'phoneNumber',
      },
      download: {
        validation: this.__urlValidationRegex,
        value: 'downloadUrl',
      },
    };

    // sets actionable buttons action
    this.__newAction = 'new';

    // check for an existing social value
    const socialValue = this.socials.find(social => social.type === value);

    this.socialTextfield.value = '';
    this.socialTextfield.pattern = '';

    // if theres a social value we want the value of the input to be the url of that social link
    if (socialValue) {
      this.socialTextfield.value = socialValue.url;
      this.__newAction = 'edit';
    }

    // if we dont have a social value (phoneNumber, email), we need to set to the property of our component here
    if (Object.keys(customMap).includes(value)) {

      if (this[customMap[value].value]) {
        this.socialTextfield.value = this[customMap[value].value];
      }

      this.socialTextfield.pattern = customMap[value].validation;

      this.__newAction = this[customMap[value]] ? 'edit' : 'new';
    } else {
      this.socialTextfield.pattern = this.__urlValidationRegex;
    }
  }

  __getContactEmails() {
    let contactString = '';

    if (!this.contactEmails) {
      return contactString;
    }

    this.contactEmails.forEach((email, i) => {
      if (i > 0) {
        contactString += ',';
      }

      contactString += email;
    });

    return contactString;
  }

  __addNewContactEmail() {
    this.contactEmails.push('');
    this.requestUpdate();
  }

  __handleContactEmailRemove(email) {
    this.contactEmails.splice(this.contactEmails.indexOf(email), 1);
    this.requestUpdate();
  }

  __handleContactEmails() {
    const dialogTextfields = this.shadowRoot.querySelectorAll('.email-input');
    const emails = [];

    let valid = true;

    Array.from(dialogTextfields).forEach(field => {
      // report invalid emails
      if (!field.reportValidity()) {
        valid = false;
      }

      emails.push(field.value);
    });

    if (!valid) {
      return;
    }

    this.contactEmails = emails;

    this.toggleDialog(this.editEmailsDialog);
  }

  __handleContactDeleted(contact) {
    const indexToRemove = this.contacts.indexOf(contact);

    if (indexToRemove > -1) {
      this.contacts.splice(indexToRemove, 1);
      this.requestUpdate();

      requestAnimationFrame(() => {
        this.__restampContacts();
      });
    }

    const formToValidate = this.shadowRoot.querySelectorAll('.contact-input');

    // lets reset the validity
    Array.from(formToValidate).forEach(input => {
      input.required = false;
      requestAnimationFrame(() => {
        input.required = true;
      });
    });

    this.toggleDialog(this.editContactsDialog);
  }

  __restampContacts() {
    const selectableContacts =
      this.shadowRoot.querySelectorAll('cbar-places-item');

    Array.from(selectableContacts).forEach(contactEle => {
      contactEle.requestUpdate();
    });
  }

  __handleEditContact(e) {
    if (!this.editing) {
      return;
    }

    this.__creatingNewContact = false;
    this.requestUpdate();

    const selectableContacts =
      this.shadowRoot.querySelectorAll('cbar-places-item');
    const selectedContact = Array.from(selectableContacts).indexOf(e.target);

    this.__selectedContact = this.contacts[selectedContact];
    this.requestUpdate();

    this.toggleDialog(this.editContactsDialog);
  }

  __confirmEditContact() {
    const formToValidate = this.shadowRoot.querySelectorAll('.contact-input');
    const userObject = {};

    let validForm = true;

    Array.from(formToValidate).forEach(element => {
      if (!element.reportValidity()) {
        validForm = false;
      } else {
        userObject[element.name] = element.value;
      }
    });

    if (!validForm) {
      return;
    }

    const contactToEditIndex = this.contacts.indexOf(this.__selectedContact);

    if (contactToEditIndex > -1) {
      this.contacts[contactToEditIndex] = userObject;
    } else {
      this.contacts.push(userObject);
    }

    this.requestUpdate();

    requestAnimationFrame(() => {
      this.__restampContacts();
    });

    this.toggleDialog(this.editContactsDialog);
  }

  __handleNewContact() {
    this.__creatingNewContact = true;
    this.requestUpdate();
    this.__selectedContact = false;

    requestAnimationFrame(() => {
      this.__selectedContact = {title: '', description: '', image: ''};

      this.toggleDialog(this.editContactsDialog);
    });
  }

  __handleImageRemoval(image, index) {
    this.images.splice(index, 1);
    this.requestUpdate();
  }

  __handleNewImage() {
    this.toggleDialog(this.addImageDialog);
  }

  __confirmAddedImage() {
    const imageUrlInput = this.imagesTextfield;

    if (!imageUrlInput.reportValidity()) {
      return;
    }

    this.images.push(imageUrlInput.value);
    this.requestUpdate();

    imageUrlInput.value = '';

    this.toggleDialog(this.addImageDialog);
  }

  constructor() {
    super();
    this.profileImage = null;
    this.bannerImage = null;
    this.selectedTab = 'default';
    this.description = null;
    this.title = null;
    this.contacts = [];
    this.socials = [];
    this.youtubeUrl = null;
    this.images = [];
    this.url = null;
    this.phoneNumber = null;
    this.loggedIn = false;
    this.hideEntityCountDisplay = false;
    this.entityMemberCount = 0;
    this.displayMailTo = false;

    this.chatId = '';
    this.chatAccessToken = '';
    this.chatRoomId = '';
    this.chatWording = 'Here';
    this.chatUrl = 'https://rooms.communitybuildar.com';
    this.hideChat = false;
    this.existingClient = false;
    this.chatLoading = false;

    this.followText = 'Follow';
    this.followingText = 'Following';

    this.contactEmails = [];

    this.editing = false;
    this.editable = false;

    this.hideBanner = false;
    this.hideImages = false;
    this.stickyOffset = 0;

    this.maxCropperHeight = 200;
    this.maxCropperWidth = 200;

    this.__uploadedImages = [];

    this.address = {
      title: '',
      streetAddress1: '',
      streetAddress2: '',
      streetAddress3: '',
      suburb: '',
      state: '',
      country: '',
      postcode: '',
    };

    this.googleApiKey = '';
    this.memberCountWording = 'Followers';

    this.hideAddress = false;

    this.__emailValidationRegex = '^[\\w\\-.]+@([\\w\\-]+\\.)+[\\w\\-]{2,}$';
    this.__urlValidationRegex = '[\\(http\\(s\\)?\\):\\/\\/\\(www\\.\\)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,256}\\b([\\-a-zA-Z0-9@:%_\\+.~#?&\\/\\/=]*)';
    this.__titleValidationRegex = "^[a-zA-Z0-9\\-' ]*$";

    document.addEventListener('scroll', () => {
      if (!this.__handledScroll) {
        this.__handleScroll();
      }
    });
  }

  render() {
    return html`
      <style>
        ${sharedTheme} :host {
          --mdc-theme-secondary: var(
            --cbar-sys-color-secondary,
            var(--cbar-dark-primary-color, #003f83)
          );
          font-family: Roboto, Noto, sans-serif;
          height: auto;
        }

        .wrapper {
          max-width: 1080px;
          margin: 0 auto;
        }

        .album {
          padding: 0;
        }

        .sections {
          padding: 16px;
          margin-top: 16px;
          display: flex;
          justify-content: space-between;
        }

        .section {
          margin: 8px;
          flex-direction: column;
          justify-content: flex-start;
          max-width: 360px;
          width: 360px;
          flex: 1;
        }

        .card {
          margin-bottom: 24px;
          border-radius: 2px;
        }

        .section:nth-of-type(1) {
          max-width: 720px;
        }

        cbar-textfield,
        cbar-dropdown {
          --mdc-theme-primary: var(--cbar-sys-color-primary, #004ca2);
        }

        h5 {
          margin-top: 0;
        }

        .sub-heading,
        .thank-you-description,
        .project-overview {
          font-size: 14px;
        }

        .thank-you-description {
          margin-top: 8px;
        }

        .poster-div {
          width: 100%;
          margin-bottom: 24px;
        }

        .social-button {
          color: white;
          margin-right: 8px;
          margin-bottom: 8px;

          --mdc-icon-button-size: 40px;

          border-radius: 50%;
          background-color: var(
            --cbar-sys-color-secondary,
            var(--cbar-dark-primary-color, #003f83)
          );
        }

        /*
        The styles in this section are included due to an issue with our social icons element not being compatable
        We need to update that element to remove the need of these mixins

        TODO: Update social icons element
        */
        .btn-facebook {
          background-color: var(--social-color-facebook, #3c5c99);
        }

        .btn-twitter {
          background-color: var(--social-color-twitter, black);
        }

        .btn-phone {
          background-color: var(--social-color-phone, rgb(48, 209, 88));
        }

        .btn-web {
          background-color: var(--social-color-web, #4846e3);
        }

        .btn-download {
          background-color: var(--social-color-download, #d80000);
        }

        .btn-email {
          background-color: var(--social-color-email, rgb(10, 132, 255));
        }

        .btn-linkedin {
          background-color: var(--social-color-linkedin, #007bb6);
        }

        .btn-youtube {
          background-color: var(--social-color-youtube, red);
        }

        .btn-instagram {
          background-image: linear-gradient(
            to top right,
            #feda75,
            #fa7e1e,
            #d62976,
            #962fbf,
            #4f5bd5
          );
        }

        .btn-google-plus {
          background-color: var(--social-color-google-plus, #da4f49);
        }

        .btn-fitbit {
          background-color: var(--social-color-fitbit, #00b0b9);
        }

        .btn-chat {
          background-color: var(--social-color-chat, #e6b000);
        }

        mwc-button[raised] {
          --mdc-theme-primary: var(
            --cbar-sys-color-secondary,
            var(--cbar-dark-primary-color, #003f83)
          );
          --mdc-theme-on-primary: var(
            --cbar-sys-color-on-secondary,
            var(--cbar-icon-text, white)
          );
        }

        mwc-button {
          --mdc-theme-primary: var(
            --cbar-sys-color-secondary,
            var(--cbar-dark-primary-color, #003f83)
          );
        }

        .socials-wrapper {
          display: flex;
          flex-wrap: wrap;
          padding-top: 8px;
          padding-left: 16px;
        }

        .album-section {
          padding: 0 16px;
          position: relative;
          flex-direction: row;
          z-index: 0;
        }

        .image-div {
          flex-shrink: 0;
          cursor: pointer;
          margin: 0 8px;
          position: relative;
        }

        .image-overlay {
          position: absolute;
          width: 250px;
          height: 200px;
          background: grey;
          opacity: 0.8;
          z-index: 0;

          display: flex;
          justify-content: center;
          align-items: center;
        }

        .background-color-animation {
          -webkit-transition: background-color 100ms linear;
          -ms-transition: background-color 100ms linear;
          transition: background-color 100ms linear;
        }

        .image-overlay-button {
          --mdc-theme-text-disabled-on-light: black;
        }

        .image-overlay:hover {
          background: black;
        }

        .image-overlay:hover .image-overlay-button {
          --mdc-theme-text-disabled-on-light: white;
        }

        .iframe-container {
          overflow: hidden;
          /* 16:9 aspect ratio */
          padding-top: 56.25%;
          position: relative;
          margin-top: 16px;
        }

        .iframe-container > * {
          border: 0;
          height: 100%;
          left: 0;
          position: absolute;
          top: 0;
          width: 100%;
        }

        .editing-iframe {
          border-radius: 5px;
          background-color: lightgrey;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0.8;
        }

        .editing-iframe:hover {
          background-color: grey;
        }

        .delete-button {
          --mdc-theme-primary: red;
        }

        cbar-places-item {
          border-bottom: 1px solid lightgrey;
          display: block;
        }

        cbar-photo-uploader {
          --cbar-sys-color-primary: black;
          --cbar-accent-color: lightgrey;
        }

        .nav-section {
          height: 200px;
          margin: var(--cbar-project-nav-margin, 0 0 16px);
          width: 32px;
          z-index: 1;
          position: absolute;
          display: flex;
          align-items: center;
          top: 0;
          bottom: 0;
          background: grey;
          opacity: 0.5;
          transition: 0.3s ease;
          cursor: pointer;
        }

        .sticky-buttons {
          background-color: white;
          display: flex;
          justify-content: end;
          align-items: center;
          position: fixed;
          height: var(--cbar-projects-page-sticky-height, auto);
          top: 0;
          right: 0;
          width: 100%;
          z-index: 1;
          padding: 8px !important;
        }

        .nav-section:hover {
          background: black;
        }

        .left-overlay {
          left: 16px;
        }

        .right-overlay {
          right: 16px;
        }

        .contact-form {
          display: flex;
          flex-direction: column;
        }

        .contact-dialog,
        .youtube-dialog,
        .social-dialog,
        .emails-dialog,
        .contacts-dialog,
        .images-dialog {
          width: 500px;
          max-width: 100%;
        }

        .email-input {
          flex: 1;
        }

        .nav-icon {
          --mdc-icon-size: 32px;
          color: white;
        }

        a {
          text-decoration: none;
        }

        .btn-tiktok {
          background-color: black;
        }

        div[contenteditable] {
          border: 2px solid grey;
          background: lightgrey;
          opacity: 0.8;
          outline: none;
          border-radius: 5px;
          padding: 16px;
          height: calc(100% - 64px);
          min-height: 200px;
        }

        .social-edit {
          background-color: grey !important;
          background-image: unset;
        }

        cbar-dropdown,
        cbar-textfield {
          --mdc-theme-primary: black;
        }

        /* Once we cant fit more than 2 columns, we change the flex direction*/
        @media (max-width: 720px) {
          .sections {
            flex-direction: column;
          }

          .section {
            width: 100%;
            max-width: 100%;
            margin: 0px;
          }

          .main-section {
            flex-shrink: 1;
          }

          .album-section {
            padding: 0;
          }

          .left-overlay {
            left: 0;
          }

          .right-overlay {
            right: 0;
          }

          .contact-dialog,
          .youtube-dialog,
          .social-dialog,
          .emails-dialog,
          .contacts-dialog,
          .images-dialog {
            --mdc-dialog-min-width: unset;
          }
        }
      </style>
      <cbar-entity-summary
        .banner=${this.bannerImage}
        .logo="${this.profileImage}"
        .title="${this.title}"
        .selectedTab="${this.selectedTab}"
        ?with-toast="${this.withToast}"
        member-count-term="${this.memberCountWording}"
        ?disable-profile-edit="${this.disableProfileEdit}"
        ?disable-join-button="${this.hideFollow}"
        ?hide-banner="${this.hideBanner}"
        ?editing="${this.editing}"
        joined-text="${this.localize(this.followingText)}"
        join-text="${this.localize(this.followText)}"
        entity-member-count="${this.entityMemberCount}"
        ?hide-entity-count-display="${this.hideEntityCountDisplay}"
        language="${this.language}"
        locales-file="${this.localesFile}"
        @banner-edit="${e => {
          this.__handleBanner(e);
        }}"
        @profile-edit="${e => {
          this.__handleProfile(e);
        }}"
      >
        <div slot="partials-slot" value="default" class="wrapper">
          <div
            class="sections"
            style="margin-top: 0; padding-bottom:0;display: flex; justify-content: end;align-items: end"
          >
            <div style="padding: 0 8px;" class="editing-section">
              ${this.editable ? html` ${this.editingSection} ` : html``}
            </div>
          </div>
          <div class="sections">
            <div class="section main-section">
              <div class="card" style="height: 100%">
                ${this.editing
                  ? html` <h5>${this.localize('Description')}</h5> `
                  : html``}
                <div
                  class="thank-you-description"
                  ?contentEditable="${this.editing}"
                ></div>
              </div>
            </div>
            <div class="section">
              ${this.youtubeSection}
              <div class="card">
                <h5 ?hidden="${!this.editing}">${this.localize('Connect')}</h5>
                <div class="socials-wrapper">
                  ${this.__hasConnect
                    ? html`
                      ${this.socials.map(
                        social => html`
                          ${this.getSocialSvg(social.type)
                            ? html`
                              <div>
                                <mwc-icon-button
                                  class="btn-${social.type} social-button ${this.editing ? 'social-edit' : ''}"
                                  @tap="${() => {
                                    this.handleSocialClicked(
                                      social.type,
                                      social.url
                                    );
                                  }}"
                                >
                                  <svg>${this.getSocialSvg(social.type)}</svg>
                                </mwc-icon-button>
                              </div>`
                            : html``}
                        `
                      )}
                      ${this.downloadUrl
                        ? html`
                          <div>
                            <mwc-icon-button
                              icon="download"
                              class="social-button btn-download ${this.editing
                                ? 'social-edit'
                                : ''}"
                              @tap="${() => {
                                this.handleSocialClicked(
                                  'download',
                                  this.downloadUrl
                                );
                              }}"
                            ></mwc-icon-button>
                          </div>`
                        : html``}
                      ${!this.hideChat && !this.editing
                        ? html`
                          <div>
                            <mwc-icon-button
                              icon="chat"
                              class="social-button btn-chat ${this.editing
                                ? 'social-edit'
                                : ''}"
                              @tap="${() => {
                                this.handleSocialClicked(
                                  'chat',
                                  this.chatRoomId,
                                  this.__handleChatTapped.bind(this)
                                );
                              }}"
                            ></mwc-icon-button>
                          </div>`
                        : html``}
                      ${this.url
                        ? html`
                          <div>
                            <mwc-icon-button
                              icon="web"
                              class="social-button btn-web ${this.editing
                                ? 'social-edit'
                                : ''}"
                              @tap="${() => {
                                this.handleSocialClicked('web', this.url);
                              }}"
                            ></mwc-icon-button>
                          </div>`
                        : html``}
                      ${this.__getContactEmails()
                        ? html`
                          <div>
                            <mwc-icon-button
                              icon="email"
                              class="social-button btn-email ${this.editing
                                ? 'social-edit'
                                : ''}"
                              @tap="${() => {
                                this.handleSocialClicked(
                                  'contact',
                                  null,
                                  this.editing
                                    ? this.toggleDialog(
                                    this.editEmailsDialog
                                    )
                                    : this.toggleDialog(this.contactDialog)
                                );
                              }}"
                            ></mwc-icon-button>
                          </div>
                        `
                        : html``}
                      ${this.phoneNumber
                        ? html`
                          <div>
                            <mwc-icon-button
                              icon="phone"
                              class="social-button btn-phone ${this.editing ? 'social-edit' : ''}"
                              @tap="${() => {
                                this.handleSocialClicked(
                                  'phone',
                                  this.phoneNumber,
                                  this.editing ? null : this.toggleDialog(this.phoneDialog)
                                );
                              }}"
                            ></mwc-icon-button>
                          </div>`
                        : html``}
                    `
                    : html``}
                  ${this.editing
                    ? html`
                      <div>
                        <mwc-icon-button
                          class="social-button"
                          icon="add"
                          @tap="${() => {
                            this.toggleDialog(this.socialDialog);
                          }}"
                        ></mwc-icon-button>
                      </div>
                    `
                    : html``}
                </div>
              </div>
              <div class="card">${this.addressSection}</div>
              <div class="card">
                ${!this.noContacts && (this.editing || this.contacts.length > 0)
                  ? html`
                    <h5>${this.localize('Contacts')}</h5>
                    ${this.contacts.map(
                      contact => html`
                        <cbar-places-item
                          title="${contact.title}"
                          description="${contact.description}"
                          imageShape="circle"
                          image="${contact.image}"
                          imageSizing="cover"
                          @item-selected="${e => {
                            this.__handleEditContact(e);
                          }}"
                        >
                          ${this.editing
                            ? html`
                              <mwc-icon
                                class="contact-delete"
                                icon="edit"
                              ></mwc-icon>
                            `
                            : html``}
                        </cbar-places-item>
                      `
                    )}
                  `
                  : html``}
                ${!this.noContacts && this.editing
                  ? html`
                    <cbar-places-item
                      title="${this.localize('Add New')}"
                      description="${this.localize('Add New Contact')}"
                      imageShape="circle"
                      image="https://cdn.communitybuildar.com/tmp/default.png"
                      imageSizing="cover"
                      @item-selected="${e => {
                        this.__handleNewContact(e);
                      }}"
                    ></cbar-places-item>
                  `
                  : html``}
              </div>
            </div>
          </div>
          ${!this.hideImages &&
          ((this.images && this.images.length > 0) || this.editing)
            ? html`
              <h5 style="padding-left: 16px">${this.localize('Images')}</h5>
              <div class="album-section">
                <div class="nav-section left-overlay" @tap="${() => {
                  this.handleImageNav('-250');
                }}" data-direction="Left">
                  <mwc-icon class="nav-icon">chevron_left</mwc-icon-button>
                </div>
                <div class="album horizontal-scroll">
                  ${
                    this.editing
                      ? html`
                        <div
                          class="image-div"
                          style="height:200px;width: 250px"
                        >
                          <div
                            class="image-overlay background-color-animation"
                            @tap="${() => {
                              this.__handleNewImage();
                            }}"
                          >
                            <mwc-icon-button
                              class="image-overlay-button"
                              disabled
                              icon="add"
                            ></mwc-icon-button>
                          </div>
                        </div>
                      `
                      : html``
                  }

                  ${this.images.map(
                    (image, index) =>
                      html`
                        <div class="image-div">
                          ${this.editing
                            ? html`
                              <div
                                class="image-overlay background-color-animation"
                                @tap="${() => {
                                  this.__handleImageRemoval(image, index);
                                }}"
                              >
                                <mwc-icon-button
                                  class="image-overlay-button"
                                  disabled
                                  icon="delete"
                                ></mwc-icon-button>
                              </div>
                            `
                            : html``}
                          <iron-image
                            src="${image}"
                            sizing="cover"
                            style="width: 250px; height: 200px"
                            @tap="${() => {
                              this.handleImageClicked(image, index);
                            }}"
                          ></iron-image>
                        </div>`
                  )}
                </div>
                <div class="nav-section right-overlay" @tap="${() => {
                  this.handleImageNav('250');
                }}" data-direction="Right">
                  <mwc-icon class="nav-icon">chevron_right</mwc-icon-button>
                </div>
              </div>
            `
            : html``}
          <div style="margin-bottom: 100px">
            <div>
              <cbar-chat-client
                class="chat-client"
                ?hidden="${!this.loggedIn || this.hideChat}"
                access-token=${this.chatAccessToken}
                ?loading=${this.chatLoading}
                room-id=${this.chatRoomId}
                user-id=${this.chatId}
                .existingClient=${this.existingClient}
                chat-wording="${this.chatWording}"
                chat-url="${this.chatUrl}"
                style="padding: 8px"
              >
                <slot name="chat-footer"></slot>
              </cbar-chat-client>
              <div
                ?hidden="${this.loggedIn || this.hideChat}"
                style="padding: 16px"
              >
                <h5>Chat</h5>
                <div class="body-display-container">
                  <div>You need to be logged in to be able to chat.</div>
                  <mwc-button
                    raised
                    style="margin:16px 0 ;"
                    @tap="${e => {
                      this.fireLogIn(e);
                    }}"
                  >Log In
                  </mwc-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </cbar-entity-summary>

      <cbar-photo-preview
        @navigate-back="${() => {
          this.handleImageNavigate('back');
        }}"
        @navigate-forward="${() => {
          this.handleImageNavigate('forward');
        }}"
      ></cbar-photo-preview>

      <md-dialog class="contact-dialog">
        <h6 slot="headline">${this.localize('Email')}</h6>
        <div style="display: flex; flex-direction: column;" slot="content">
          ${this.loggedIn
            ? html`
              ${!this.displayMailTo
                ? html`
                  <mwc-textfield
                    name="subject"
                    class="contact-form-input"
                    label=${this.localize('Subject')}
                    required
                    validationMessage=${this.localize('Required')}
                  ></mwc-textfield>
                  <mwc-textarea
                    name="message"
                    class="contact-form-input"
                    label=${this.localize('Message')}
                    required
                    validationMessage=${this.localize('Required')}
                  ></mwc-textarea>
                  <mwc-formfield label="${this.localize('Send Me A Copy')}">
                    <mwc-checkbox
                      class="contact-form-input"
                      name="sendCopy"
                      value="sendCopy"
                    ></mwc-checkbox>
                  </mwc-formfield>
                `
                : html`
                  ${this.__getContactEmails()
                    ? html`
                      <div>To Contact The Administrators Click<a href="mailto:${this.__getContactEmails()}">Here</a></div>`
                    : html`<div>No Contacts Are Available For This Group</div>
                    `}
                `}`
            : html`
              <div>Emailing ${this.title} requires logging in.</div> `}
        </div>
        <div slot="actions">
          <mwc-button class="contact-close" @tap="${() => {this.handleContactDialogClose();}}">${this.localize('Cancel')}</mwc-button>
          ${this.contactFormSubmitButton}
        </div>
      </md-dialog>

      <md-dialog  class="phone-dialog">
        <h6 slot="headline">${this.localize('Phone Number')}</h6>
        <div style="display: flex; align-items: center" slot="content">
          <mwc-icon style="margin-right: 16px;">phone</mwc-icon>
          <a href="tel:${this.phoneNumber}">${this.phoneNumber}</a>
        </div>
        <div slot="actions">
            <mwc-button slot="primaryAction" @tap="${() => {this.phoneDialog.close()}}">${this.localize('Close')}</mwc-button>
        </div>
      </md-dialog>

      <md-dialog scrimClickAction="" heading="${this.localize('Are you sure?')}" class="confirmation-dialog">
        <h6 slot="headline"></h6>
        <div slot="content">${this.localize('Any unsaved information may be lost')}</div>
        <div slot="actions">
          <mwc-button slot="secondaryAction" @tap="${() => {this.confirmDialog.close()}}">${this.localize('Cancel')}</mwc-button>
          <mwc-button slot="primaryAction" @tap="${() => {this.confirmContactCancel();}}">${this.localize('Confirm')}</mwc-button>
        </div>
      </md-dialog>

      ${this.youtubeDialogElement} ${this.socialDialogElement}
      ${this.emailsDialogElement} ${this.editContactsDialogElement}
      ${this.addImageDialogElement}

      <cbar-photo-uploader
        @uploaded-image="${e => {
          this.__handleUploadedImage(e);
        }}"
      ></cbar-photo-uploader>
    `;
  }

  cancelYoutubeEdit() {
    const newInput = this.shadowRoot.querySelector(
      'cbar-textfield.youtube-url'
    );

    newInput.required = false;
    requestAnimationFrame(() => {
      newInput.required = true;
    });

    this.youtubeDialog.close();
  }

  // eslint-disable-next-line class-methods-use-this
  getYoutubeIdFromUrl(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
  }

  __handleScroll() {
    this.__handledScroll = true;

    const editButtonsDiv = this.shadowRoot.querySelector('.editing-section');
    const sectionToCheck = this.__initialButtonsPosition ? this.__initialButtonsPosition : editButtonsDiv.offsetTop + editButtonsDiv.offsetHeight;

    if (this.editing && window.scrollY >= sectionToCheck) {
      if (!this.__initialButtonsPosition) {
        this.__initialButtonsPosition = editButtonsDiv.offsetTop + editButtonsDiv.offsetHeight;
      }

      editButtonsDiv.classList.add('sticky-buttons');
    } else if (editButtonsDiv.classList.contains('sticky-buttons') && window.scrollY < (sectionToCheck - 52)) {
      editButtonsDiv.classList.remove('sticky-buttons');
    }

    setTimeout(() => {
      this.__handledScroll = false;
    }, 50);
  }

  __handleBanner() {
    this.__imageUploadTarget = 'banner';

    this.photoUploader.maxHeight = 0;
    this.photoUploader.maxWidth = 0;

    this.photoUploader.$.dialog.open();
    requestAnimationFrame(() => {
      this.photoUploader.type = 'cover';
    });
  }

  __handleProfile() {
    this.__imageUploadTarget = 'profile';
    this.photoUploader.$.dialog.open();

    this.photoUploader.maxHeight = this.maxCropperHeight;
    this.photoUploader.maxWidth = this.maxCropperWidth;

    requestAnimationFrame(() => {
      this.photoUploader.type = 'profile';
    });
  }

  async __handleUploadedImage(e) {
    e.preventDefault();

    const imageDetails = e.detail;
    const dataUrl = imageDetails.croppedCanvas.toDataURL('image/jpeg');

    this[`${this.__imageUploadTarget}Image`] = dataUrl;

    const existingImageIndex = this.__uploadedImages.findIndex(
      image => image.type === this.__imageUploadTarget
    );

    const imageBlob = await this.getImageBlob(imageDetails.croppedCanvas);

    const imageObject = {
      type: this.__imageUploadTarget,
      filename: imageDetails.imageName,
      mimetype: imageBlob.type,
      encoding: 'utf8',
      binary: dataUrl,
    };

    if (existingImageIndex > -1) {
      this.__uploadedImages[existingImageIndex] = imageObject;
    } else {
      this.__uploadedImages.push(imageObject);
    }

    this.photoUploader._closeModal();
    this.photoUploader.__loading = false;
  }

  // eslint-disable-next-line class-methods-use-this
  getImageBlob(canvas) {
    return new Promise((res, rej) => {
      canvas.toBlob(e => {
        if (!e) {
          rej(e);
        }

        res(e);
      });
    });
  }

  getAddressFromElement() {
    const element = this.addressInput;

    if (!element) {
      return {};
    }

    return {
      title: element.title ? element.title : this.title,
      type: element.locationType,
      customType: element.customLocationType,
      streetAddress1: element.streetAddress1,
      streetAddress2: element.streetAddress2,
      streetAddress3: element.streetAddress3,
      suburb: element.suburb,
      state: element.state,
      country: element.country,
      postcode: element.postcode,
    };
  }

  deleteAddress(e) {
    this.address = {};

    const element = e.target;

    element.title = '';
    element.type = '';
    element.locationType = '';
    element.streetAddress1 = '';
    element.streetAddress2 = '';
    element.streetAddress3 = '';
    element.suburb = '';
    element.state = '';
    element.country = '';
    element.postcode = '';
  }

  async handleGoogleMap() {
    if (!this.hideAddress && this.googleApiKey) {
      const addressToUse = this.formatAddressForGoogle(true);
      const latLongResult = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?key=${this.googleApiKey}&address=${addressToUse}`
      );

      if (latLongResult.status !== 200) {
        return;
      }

      const result = await latLongResult.json();

      const geometryData = result.results[0].geometry.location;

      this.mapLocation = {
        lat: geometryData.lat,
        lng: geometryData.lng,
        title: this.address.title ? this.address.title : this.title,
        description: this.formatAddressForGoogle(),
      };
    }
  }

  formatAddressForGoogle(urlEncode = false) {
    let formattedAddress = '';
    const validFields = [
      'streetAddress1',
      'streetAddress2',
      'streetAddress3',
      'suburb',
      'state',
      'country',
      'postcode',
    ];

    validFields.forEach((field, i) => {
      if (!Object.prototype.hasOwnProperty.call(this.address, field)) {
        return;
      }

      if (i > 0 && !!this.address[field]) {
        formattedAddress += ', ';
      }

      formattedAddress += this.address[field];
    });

    return urlEncode ? encodeURIComponent(formattedAddress) : formattedAddress;
  }
}
